import React, { useState, useEffect } from "react";

export const svg = `<svg width="64" height="12" viewbox="0 0 64 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.364 5.764c.282.087.549.22.788.393.58.463.868 1.257.868 2.356v.251C12.02 10.991 10.9 12 8.427 12H0V0h7.836c2.472 0 3.572 1.005 3.572 3.251v.236c0 1.237-.268 1.814-1.044 2.277Zm-3.021-.966c.848 0 1.084-.2 1.084-.899v-.361c0-.699-.236-.9-1.084-.9H3.005v2.16h4.338Zm.595 4.548c.868 0 1.085-.197 1.085-.9v-.36c0-.7-.217-.896-1.085-.896H3.005v2.156h4.933ZM19 9.355h6.947V12H16V0h3v9.355ZM30 12V0h3.109v12H30Zm11.5 0V2.626H37V0h12v2.626h-4.5V12h-3Zm22.276 0H53V9.355l6.95-6.73H53V0h10.776v2.626l-6.95 6.729h6.95V12Z" fill="#fff"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
